export default {
  shuffleLevels: true,
  shuffleAnswers: true,
  levels: [
    {
      question: 'Która z postaci pracowała jako masażystka?',
      answers: [
        {
          content: 'Phoebe',
          value: 1,
        },
        {
          content: 'Rachel',
          value: 0,
        },
        {
          content: 'Monica',
          value: 0,
        },
      ],
    },
    {
      question: 'Który z bohaterów robi sobie tatuaż na biodrze?',
      answers: [
        {
          content: 'Monica',
          value: 0,
        },
        {
          content: 'Rachel',
          value: 1,
        },
        {
          content: 'Ross',
          value: 0,
        },
      ],
    },
    {
      question: 'Jak brzmi drugie imię Chandlera?',
      answers: [
        {
          content: 'Randy',
          value: 0,
        },
        {
          content: 'Muriel',
          value: 1,
        },
        {
          content: 'Jimmy',
          value: 0,
        },
      ],
    },
    {
      question: 'Jak nazywa się małpka, którą miał Ross?',
      answers: [
        {
          content: 'Smelly',
          value: 0,
        },
        {
          content: 'Marcel',
          value: 1,
        },
        {
          content: 'Cluckers',
          value: 0,
        },
      ],
    },
    {
      question: 'Jaki zawód wykonuje Joey?',
      answers: [
        {
          content: 'Kucharz',
          value: 0,
        },
        {
          content: 'Aktor',
          value: 1,
        },
        {
          content: 'Dentysta',
          value: 0,
        },
      ],
    },
    {
      question: 'W jakim mieście mieszkają serialowi Przyjaciele?',
      answers: [
        {
          content: 'Miami',
          value: 0,
        },
        {
          content: 'Nowy Jork',
          value: 1,
        },
        {
          content: 'Los Angeles',
          value: 0,
        },
      ],
    },
    {
      question: 'Do którego artysty Phoebe otrzymuje zakaz zbliżania się? ',
      answers: [
        {
          content: 'Elton John',
          value: 0,
        },
        {
          content: 'Sting',
          value: 1,
        },
        {
          content: 'Rod Stewart',
          value: 0,
        },
      ],
    },
    {
      question: 'Ile sióstr ma Rachel?',
      answers: [
        {
          content: '1',
          value: 0,
        },
        {
          content: '2',
          value: 1,
        },
        {
          content: '3',
          value: 0,
        },
      ],
    },
    {
      question: 'Jak na imię miał barista w Central Perku?',
      answers: [
        {
          content: 'Gunner',
          value: 0,
        },
        {
          content: 'Gunther',
          value: 1,
        },
        {
          content: 'Matthew',
          value: 0,
        },
      ],
    },
    {
      question: 'Czyją wypowiedzią rozpoczyna się serial Przyjaciele?',
      answers: [
        {
          content: 'Rossa',
          value: 0,
        },
        {
          content: 'Monici',
          value: 1,
        },
        {
          content: 'Chandlera',
          value: 0,
        },
      ],
    },
    {
      question: 'Którzy z przyjaciół byli partnerami od drzemki?',
      answers: [
        {
          content: 'Chandler i Joey',
          value: 0,
        },
        {
          content: 'Joey i Ross',
          value: 1,
        },
        {
          content: 'Chandler i Ross',
          value: 0,
        },
      ],
    },
    {
      question: 'Na jaką okazję Chandler miał przygotowany specjalny śmiech? ',
      answers: [
        {
          content: 'Na randki',
          value: 0,
        },
        {
          content: 'Do pracy',
          value: 1,
        },
        {
          content: 'Na wesela',
          value: 0,
        },
      ],
    },
    {
      question: 'Gdzie Ross i Emily pojechali tuż po swojej pierwszej randce?',
      answers: [
        {
          content: 'Los Angeles',
          value: 0,
        },
        {
          content: 'Vermont',
          value: 1,
        },
        {
          content: 'Waszyngton',
          value: 0,
        },
      ],
    },
    {
      question: 'Jak nazywała się szefowa Rachel, która miała romans z Chandlerem?',
      answers: [
        {
          content: 'Alice',
          value: 0,
        },
        {
          content: 'Joanna',
          value: 1,
        },
        {
          content: 'Julie',
          value: 0,
        },
      ],
    },
    {
      question: 'Kto NIE wystąpił nigdy gościnnie w serialu Przyjaciele?',
      answers: [
        {
          content: 'Reese Witherspoon',
          value: 0,
        },
        {
          content: 'Hugh Grant',
          value: 1,
        },
        {
          content: 'Julia Roberts',
          value: 0,
        },
      ],
    },
    {
      question: 'W jakim kraju emitowano reklamę Ichiban - szminkę dla mężczyzn?',
      answers: [
        {
          content: 'W Chinach',
          value: 0,
        },
        {
          content: 'W Japonii',
          value: 1,
        },
        {
          content: 'W Korei Południowej',
          value: 0,
        },
      ],
    },
    {
      question: 'Kto próbuje nauczyć Joeya francuskiego?',
      answers: [
        {
          content: 'Rachel',
          value: 0,
        },
        {
          content: 'Phoebe',
          value: 1,
        },
        {
          content: 'Ross',
          value: 0,
        },
      ],
    },
    {
      question: 'Kto wykonuje piosenkę w czołówce Przyjaciół?',
      answers: [
        {
          content: 'The Carpenters',
          value: 0,
        },
        {
          content: 'The Rembrandts',
          value: 1,
        },
        {
          content: 'The Police',
          value: 0,
        },
      ],
    },
    {
      question: 'Ulubiona maskotka Joey\'a to..? ',
      answers: [
        {
          content: 'Lew',
          value: 0,
        },
        {
          content: 'Pingwin',
          value: 1,
        },
        {
          content: 'Panda',
          value: 0,
        },
      ],
    },
  ],
};
